import * as React from 'react'
import { createContext, useContextSelector } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'
import { BOOKING_SITES, SITE_STRING_EXCEPTIONS } from 'app/@common/constants'
import { PackagesSubmittedFiltersContext } from '../../../../Providers'
import { useEffect } from 'react'

const Context = createContext({})

const bookingSites = [
    BOOKING_SITES.APP, BOOKING_SITES.GENIUS, BOOKING_SITES.MOBILE, BOOKING_SITES.COM, BOOKING_SITES.MX, BOOKING_SITES.CN, BOOKING_SITES.BASIC, BOOKING_SITES.CORE,
    BOOKING_SITES.PAY, BOOKING_SITES.BR, BOOKING_SITES.PT, BOOKING_SITES.US, BOOKING_SITES.UK
];

export function PackagesTablesCheckElementsProvider({children}) {
    const { state , updateState } = useAppContextState({})
    const idSite = useContextSelector(PackagesSubmittedFiltersContext, ({ state }) => state.id_site)

    useEffect(() => {
        updateState({ checkElements: [{
                label: 'Site name',
                i18nKey: 'checks.siteName',
                isActive: false,
                visible: true,
                styleTag: {
                    backgroundColor: '#C1ECFF',
                    color: '#000'
                }
                },
                {
                    label: 'Cancellation Policy',
                    i18nKey: 'checks.cancellationPolicy',
                    isActive: false,
                    visible: true,
                    styleTag: {
                        backgroundColor: '#12A3B9',
                        color: '#FFF'
                    }
                },
                {
                    label: 'Meal plan',
                    i18nKey: 'checks.mealPlan',
                    isActive: false,
                    visible: true,
                    styleTag: {
                        backgroundColor: '#E0FF4F',
                        color: '#000'
                    }
                },
                {
                    label: '3rd Supplier',
                    i18nKey: 'checks.thirdSupplier',
                    description: 'Displays rates through third party suppliers',
                    descriptionI18nKey: 'checks.thirdSupplierDesc',
                    isActive: false,
                    visible: bookingSites.includes(idSite),
                    styleTag: {
                        backgroundColor: '#F79F79',
                        color: '#000',
                        display: bookingSites.includes(idSite) ? 'inline-block' : 'none'
                    }
                },
                {
                    label: 'Device',
                    i18nKey: 'checks.device',
                    isActive: false,
                    visible: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite,
                    styleTag: {
                        backgroundColor: '#00D1C0',
                        color: '#FFF',
                        display: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite ? 'inline-block' : 'none'
                    }
                },
                {
                    label: 'Booking Pay',
                    i18nKey: 'checks.bookingPay',
                    description: 'Special deals for non direct payments',
                    descriptionI18nKey: 'checks.bookingPayDesc',
                    isActive: false,
                    visible: bookingSites.includes(idSite),
                    styleTag: {
                        backgroundColor: '#2474B2',
                        color: '#FFF',
                        display: bookingSites.includes(idSite) ? 'inline-block' : 'none'
                    }
                },
                {
                    label: 'Channel',
                    i18nKey: 'checks.channel',
                    isActive: false,
                    visible: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite,
                    styleTag: {
                        backgroundColor: '#2474B2',
                        color: '#FFF',
                        display: SITE_STRING_EXCEPTIONS.OFFICIAL_SITE.toLowerCase() === idSite ? 'inline-block' : 'none'
                    }
                },
                {
                    label: 'Room name',
                    i18nKey: 'checks.roomName',
                    isActive: false,
                    visible: true,
                    styleTag: {
                        backgroundColor: '#DBC9FF',
                        color: '#000'
                    }
                },
                {
                    label: 'Room name Raw',
                    i18nKey: 'checks.roomNameRaw',
                    isActive: false,
                    visible: true,
                    styleTag: {
                        backgroundColor: '#8ABEE5',
                        color: '#000'
                    }
                },
                {
                    label: 'vs Main Hotel %',
                    i18nKey: 'checks.vsMainHotel',
                    description: 'Shows the price difference vs the main hotel as a percentage under each cell',
                    descriptionI18nKey: 'checks.vsMainHotelDesc',
                    isActive: false,
                    visible: true,
                    styleTag: {
                        backgroundColor: '#9333EA',
                        color: '#FFF'
                    }
                },
                {
                    label: 'vs Min Site %',
                    i18nKey: 'checks.vsMinSite',
                    description: 'Shows the price difference of each site row vs the Min site of the same hotel',
                    descriptionI18nKey: 'checks.vsMinSiteDesc',
                    isActive: false,
                    visible: true,
                    styleTag: {
                        backgroundColor: '#0EA5E9',
                        color: '#FFF'
                    }
                }
            ]})
    }, [idSite, updateState])

    return <Context.Provider value={{state, updateState}}>
        {children}
    </Context.Provider>
}

export default Context